import axios, { AxiosRequestConfig, AxiosResponse } from 'axios'
import { getCardServerToken, getStorage, removeStorage } from '@/lib/utility'
import qs from 'qs'
import { createLogger } from 'vuex'
import router from '@/router'

interface Options {
  method: string;
  body?: object;
  payload?: object;
}

axios.interceptors.request.use((config: AxiosRequestConfig): AxiosRequestConfig => {
  if (config.url?.includes('newiot') || config.url?.includes('rechargeApi')) {
    config.headers['Qhyl-Token'] = getCardServerToken(config.method === 'post' ? config.data : config.params)
  }
  if (getStorage('token')) {
    config.headers.Authorization = getStorage('token')
  }
  if (config.method === 'post' && (config.url?.includes('opApi') || config.url?.includes('accountCenter') || config.url?.includes('pushdata-java'))) {
    config.data = qs.stringify(config.data)
  }
  return config
}, (err) => {
  return Promise.reject(err)
})

axios.interceptors.response.use((res: AxiosResponse): AxiosResponse<any> => {
  return res.data
}, (err) => {
  // console.log(err.response)
  if (err.response.data.code === 2007 && err.response.config.url?.indexOf('equipmentIot')) {
    // localStorage.clear()
    removeStorage('userInfo')
    removeStorage('isLogin')
    router.push('/equipment/login')
    const data = {
      status: 0,
      msg: '登录失效'
    }
    return Promise.resolve(data)
  } else {
    return Promise.resolve(err.response.data)
  }
  // const ErrData: any = {}
  // if (err.response.status != 200) {
  //   ErrData.status = err.response.status
  //   ErrData.state = err.response.status
  //   ErrData.msg = err.response.data
  //   return Promise.resolve(ErrData)
  // }
})

export function request (url: string, option: Options) {
  const options = {
    ...option
  }
  if (options.method === 'POST') {
    return axios({
      method: 'post',
      url,
      data: options.body
    })
  } else if (options.method === 'GET') {
    return axios({
      method: 'get',
      url,
      params: options.payload
    })
  }
}
